(function(){
  'use strict';
  var A = window.Arca || {root:'/', money:'${{amount}}'};
  var root = (A.root || '/').replace(/\/?$/, '/');
  var MONEY = String(A.money || '${{amount}}').replace(/<[^>]*>/g, '');

  function fmt(cents){
    cents = typeof cents === 'string' ? parseInt(cents.replace('.',''),10) : cents;
    function num(n, d, ts, ds){
      d = d === undefined ? 2 : d; ts = ts || ','; ds = ds || '.';
      var s = (n/100).toFixed(d).split('.');
      return s[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1'+ts) + (s[1] ? ds + s[1] : '');
    }
    return MONEY.replace(/\{\{\s*(\w+)\s*\}\}/, function(_, k){
      if (k === 'amount_no_decimals') return num(cents, 0);
      if (k === 'amount_with_comma_separator') return num(cents, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return num(cents, 0, '.', ',');
      return num(cents, 2);
    });
  }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function img(src, w){
    if (!src) return '';
    if (typeof src === 'object') src = src.src || src.url || '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* drawer */
  var drawer = document.getElementById('ArcaDrawer');
  function setDrawer(open){ if(!drawer) return; drawer.classList.toggle('is-open', open); drawer.setAttribute('aria-hidden', open ? 'false' : 'true'); document.documentElement.style.overflow = open ? 'hidden' : ''; }
  document.addEventListener('click', function(e){
    if (e.target.closest('[data-drawer-open]')) { e.preventDefault(); setDrawer(true); }
    else if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); setDrawer(false); }
  });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') setDrawer(false); });

  /* close filter dropdowns when clicking outside */
  document.addEventListener('click', function(e){
    document.querySelectorAll('.a-filter[open]').forEach(function(d){ if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  /* cards from a section-rendered collection (best sellers) */
  document.querySelectorAll('[data-arca-cards]').forEach(function(el){
    var limit = parseInt(el.getAttribute('data-limit') || '4', 10);
    fetch(el.getAttribute('data-arca-cards')).then(function(r){ return r.text(); }).then(function(html){
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var cards = [].filter.call(doc.querySelectorAll('.a-card'), function(c){ return !c.querySelector('.a-badge--sold'); });
      for (var i = 0; i < cards.length && i < limit; i++) el.appendChild(document.importNode(cards[i], true));
    }).catch(function(){});
  });

  /* load more on collection pages */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-arca-more]');
    if (!btn) return;
    e.preventDefault();
    var url = btn.getAttribute('href');
    btn.textContent = 'Loading…';
    fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=arca-collection').then(function(r){ return r.text(); }).then(function(html){
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var grid = document.getElementById('ArcaGrid');
      doc.querySelectorAll('#ArcaGrid .a-card').forEach(function(c){ grid.appendChild(document.importNode(c, true)); });
      var total = parseInt(btn.getAttribute('data-total'), 10) || 0;
      var shown = grid.querySelectorAll('.a-card').length;
      var lbl = document.querySelector('[data-arca-shown]'); if (lbl) lbl.textContent = 'Showing ' + shown + ' of ' + total;
      var bar = document.querySelector('[data-arca-bar]'); if (bar && total) bar.style.width = Math.min(100, Math.round(shown*100/total)) + '%';
      var next = doc.querySelector('[data-arca-more]');
      if (next) { btn.setAttribute('href', next.getAttribute('href')); btn.textContent = 'Load more'; }
      else btn.remove();
    }).catch(function(){ window.location = url; });
  });

  /* product page: variants */
  var pj = document.getElementById('ArcaProductJSON');
  var product = null;
  if (pj) {
    product = JSON.parse(pj.textContent);
    var form = document.getElementById('ArcaProductForm');
    var idInput = form && form.querySelector('[data-arca-variant]');
    var current = function(){
      var opts = [];
      document.querySelectorAll('.a-opt').forEach(function(fs, i){ var c = fs.querySelector('input:checked'); opts[i] = c ? c.value : null; });
      return product.variants.find(function(v){ return v.options.every(function(o, i){ return opts[i] === null || o === opts[i]; }); });
    };
    var markAvailability = function(){
      var groups = document.querySelectorAll('.a-opt');
      groups.forEach(function(fs, i){
        fs.querySelectorAll('input').forEach(function(inp){
          var ok = product.variants.some(function(v){
            if (!v.available || v.options[i] !== inp.value) return false;
            return v.options.every(function(o, j){ if (j === i) return true; var c = groups[j].querySelector('input:checked'); return !c || c.value === o; });
          });
          var lab = fs.querySelector('label[for="' + inp.id + '"]'); if (lab) lab.classList.toggle('is-na', !ok);
        });
      });
    };
    var update = function(){
      var v = current();
      document.querySelectorAll('.a-opt').forEach(function(fs, i){ var c = fs.querySelector('input:checked'); var o = document.querySelector('[data-arca-optval="' + i + '"]'); if (o && c) o.textContent = c.value; });
      markAvailability();
      var adds = document.querySelectorAll('[data-arca-add]');
      var t = document.querySelector('[data-arca-addtxt]');
      if (!v) { adds.forEach(function(b){ b.disabled = true; }); if (t) t.textContent = 'Unavailable'; return; }
      if (idInput) idInput.value = v.id;
      var p = document.querySelector('[data-arca-price]'); if (p) p.innerHTML = esc(fmt(v.price)) + (v.compare_at_price > v.price ? '<s>' + esc(fmt(v.compare_at_price)) + '</s>' : '');
      var ps = document.querySelector('[data-arca-price-s]'); if (ps) ps.textContent = fmt(v.price);
      adds.forEach(function(b){ b.disabled = !v.available; });
      if (t) t.textContent = v.available ? 'Add to bag · ' + fmt(v.price) : 'Sold out';
      document.querySelectorAll('.a-sticky [data-arca-add]').forEach(function(b){ b.textContent = v.available ? 'Add to bag' : 'Sold out'; });
      var st = document.querySelector('[data-arca-stock]');
      if (st) st.innerHTML = v.available ? '<div class="a-stock a-stock--ok">Available</div>' : '<div class="a-stock">Sold out</div>';
      if (v.featured_media) { var m = document.querySelector('.a-gal__m[data-media-id="' + v.featured_media.id + '"]'); var g = document.getElementById('ArcaGallery'); if (m && g) { if (window.matchMedia('(max-width:1100px)').matches) g.scrollTo({left: m.offsetLeft, behavior: 'smooth'}); else m.scrollIntoView({behavior: 'smooth', block: 'center'}); } }
      if (history.replaceState) { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); }
    };
    document.addEventListener('change', function(e){ if (e.target.matches('[data-arca-opt]')) update(); });
    if (document.querySelector('.a-opt')) markAvailability();
  }

  /* recommendations: product page + cart */
  var JEWEL = ['rings','earrings','necklaces','bracelets','sets'];
  function has(list, h){ return new RegExp('(^|,)' + h + '(,|$)').test(list); }
  function norm(p){
    var vars = (p.variants || []).map(function(v){ return { id: v.id, available: v.available !== false, price: typeof v.price === 'string' ? Math.round(parseFloat(v.price) * 100) : v.price }; });
    var avail = vars.filter(function(v){ return v.available; });
    var first = avail[0] || vars[0] || {};
    var prices = vars.map(function(v){ return v.price; });
    var image = p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
    return { id: p.id, title: p.title || '', url: p.url || (root + 'products/' + p.handle), image: image, available: avail.length > 0, price: first.price || 0, varies: prices.length > 1 && Math.min.apply(null, prices) !== Math.max.apply(null, prices), single: vars.length === 1, vid: first.id, cmp: typeof p.compare_at_price === 'number' ? p.compare_at_price : 0 };
  }
  function key(t){ return String(t || '').trim().toLowerCase(); }
  function pairsFor(cat, sub){
    if (cat === 'scarf') return ['earrings', 'necklaces'];
    if (cat === 'jewelry') return ['scarves', sub === 'earrings' ? 'necklaces' : 'earrings'];
    return ['earrings', 'scarves'];
  }
  function cartPairs(cats){
    var hasScarf = has(cats, 'scarves');
    var hasJ = JEWEL.some(function(h){ return has(cats, h); });
    if (hasScarf && hasJ) return ['bracelets', 'necklaces'];
    if (hasScarf) return ['earrings', 'necklaces'];
    if (hasJ) return ['scarves', has(cats, 'earrings') ? 'necklaces' : 'earrings'];
    return ['earrings', 'scarves'];
  }
  /* interleave the collections; prefer pieces at or under maxPrice, then fill with the rest */
  function fromCollections(handles, n, skipIds, skipTitles, maxPrice){
    if (n <= 0) return Promise.resolve([]);
    return Promise.all(handles.map(function(h){
      return fetch(root + 'collections/' + h + '/products.json?limit=60')
        .then(function(r){ return r.ok ? r.json() : {products: []}; })
        .then(function(d){ return (d.products || []).map(norm); })
        .catch(function(){ return []; });
    })).then(function(lists){
      var out = [], seen = {};
      skipTitles.forEach(function(t){ seen[key(t)] = 1; });
      var max = 0; lists.forEach(function(l){ if (l.length > max) max = l.length; });
      [true, false].forEach(function(priced){
        for (var i = 0; i < max && out.length < n; i++) {
          for (var j = 0; j < lists.length && out.length < n; j++) {
            var p = lists[j][i];
            if (!p || !p.available || !p.image || seen[key(p.title)] || skipIds.indexOf(String(p.id)) > -1) continue;
            if (priced && maxPrice && p.price > maxPrice) continue;
            seen[key(p.title)] = 1; out.push(p);
          }
        }
      });
      return out;
    });
  }
  function addForm(p){
    return p.single && p.available
      ? '<form method="post" action="' + root + 'cart/add" class="a-card__add"><input type="hidden" name="id" value="' + esc(p.vid) + '"><input type="hidden" name="quantity" value="1"><button type="submit" class="a-btn">Add to bag</button></form>'
      : '<div class="a-card__add"><a href="' + esc(p.url) + '" class="a-btn a-btn--o">Choose options</a></div>';
  }
  function cardHtml(p, withAdd){
    var badge = !p.available ? '<span class="a-badge a-badge--sold">Sold out</span>' : '';
    var img1 = p.image ? '<img src="' + esc(img(p.image, 700)) + '" alt="' + esc(p.title) + '" loading="lazy" width="700" height="875">' : '';
    var cmp = p.cmp > p.price ? '<s>' + esc(fmt(p.cmp)) + '</s>' : '';
    return '<div class="a-card"><a href="' + esc(p.url) + '" class="a-card__img">' + img1 + badge + '</a><a href="' + esc(p.url) + '" class="a-card__meta"><span>' + esc(p.title) + '</span><span class="a-card__price">' + cmp + (p.varies ? 'From ' : '') + esc(fmt(p.price)) + '</span></a>' + (withAdd ? addForm(p) : '') + '</div>';
  }
  function lookHtml(p){
    var btn = p.single && p.available
      ? '<form method="post" action="' + root + 'cart/add"><input type="hidden" name="id" value="' + esc(p.vid) + '"><button type="submit" class="a-btn">Add</button></form>'
      : '<a href="' + esc(p.url) + '" class="a-btn a-btn--o" style="padding:10px 14px;font-size:12px">View</a>';
    return '<div class="a-look__item"><a href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(img(p.image, 300)) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a><div><a href="' + esc(p.url) + '" style="font-size:15px;line-height:1.3;display:block">' + esc(p.title) + '</a><div class="a-small">' + (p.varies ? 'From ' : '') + esc(fmt(p.price)) + '</div></div>' + btn + '</div>';
  }
  function recs(pid, intent, n){
    if (!pid) return Promise.resolve([]);
    return fetch(root + 'recommendations/products.json?product_id=' + pid + '&limit=' + n + '&intent=' + intent)
      .then(function(r){ return r.ok ? r.json() : {products: []}; })
      .then(function(d){ return (d.products || []).map(norm); })
      .catch(function(){ return []; });
  }
  document.querySelectorAll('[data-arca-recs]').forEach(function(sec){
    var intent = sec.getAttribute('data-arca-recs');
    var limit = parseInt(sec.getAttribute('data-limit') || '4', 10);
    var host = document.querySelector('[data-arca-product]');
    var pid = sec.getAttribute('data-product-id') || (host && host.getAttribute('data-product-id'));
    var exclude = (sec.getAttribute('data-exclude') || '').split(',').filter(Boolean);
    if (pid) exclude.push(String(pid));
    var titles = (sec.getAttribute('data-titles') || '').split('|').map(key).filter(Boolean);
    var keep = function(p){ return p.available && exclude.indexOf(String(p.id)) === -1 && titles.indexOf(key(p.title)) === -1; };
    var dedupe = function(list){ var seen = {}; return list.filter(function(p){ var t = key(p.title); if (seen[t]) return false; seen[t] = 1; return true; }); };
    var job, render = cardHtml, withAdd = false;
    if (intent === 'cart') {
      withAdd = true;
      job = fromCollections(cartPairs(sec.getAttribute('data-cats') || ''), limit, exclude, titles, 12000);
    } else if (intent === 'complementary') {
      render = lookHtml;
      var cat = sec.getAttribute('data-cat') || (host && host.getAttribute('data-cat')) || 'other';
      var sub = sec.getAttribute('data-sub') || (host && host.getAttribute('data-sub')) || '';
      var cap = Math.max(Math.round(((product && product.price) || 0) * 1.5), 6000);
      job = recs(pid, 'complementary', limit).then(function(list){
        list = dedupe(list.filter(keep)).slice(0, limit);
        if (list.length >= limit) return list;
        return fromCollections(pairsFor(cat, sub), limit - list.length, exclude.concat(list.map(function(p){ return String(p.id); })), titles.concat(list.map(function(p){ return p.title; })), cap)
          .then(function(more){ return list.concat(more); });
      });
    } else {
      if (!pid) return;
      job = recs(pid, 'related', limit + 6).then(function(list){ return dedupe(list.filter(keep)).slice(0, limit); });
    }
    job.then(function(list){
      if (!list.length) return;
      sec.querySelector('[data-arca-recs-list]').innerHTML = list.map(function(p){ return render(p, withAdd); }).join('');
      sec.hidden = false;
    });
  });

  /* cart quantity steppers */
  function submitCart(f){ var h = document.createElement('input'); h.type = 'hidden'; h.name = 'update'; h.value = '1'; f.appendChild(h); f.submit(); }
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-arca-step]');
    if (!b) return;
    var input = b.parentNode.querySelector('input');
    input.value = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-arca-step'), 10));
    var f = b.closest('form'); if (f) submitCart(f);
  });
  document.addEventListener('change', function(e){
    if (e.target.matches('#ArcaCart input[name="updates[]"]')) submitCart(e.target.form);
  });
})();
